import { useEditorStore } from "@/store/editorStore";

/**
 * Whether the reader may change this document: the owner and editors may,
 * viewers may not. The API already refuses a viewer's writes (403); the
 * editor has to know too, or it lets them type and then fails to save.
 * No role at all (an older API, a document being created) means editable —
 * the server still has the last word.
 */
export function canEdit(doc: { role?: string | null } | null | undefined): boolean {
  const role = doc?.role;
  return !role || role === "owner" || role === "editor";
}

/**
 * Whether the reader owns this document. Anything else in their list (editor,
 * viewer, a team's or a group's document) was shared with them. No role means
 * their own, as for canEdit.
 */
export function isOwn(role?: string | null): boolean {
  return !role || role.toLowerCase() === "owner";
}

/** canEdit for the document open in the editor. */
export function useCanEdit(): boolean {
  return useEditorStore((s) => canEdit(s.document as { role?: string } | null));
}
